module.exports = __webpack_public_path__ + "static/media/Logo.43d0d54a.webp";